import { render, staticRenderFns } from "./UserAction.vue?vue&type=template&id=13fb4df4&scoped=true&"
import script from "./UserAction.vue?vue&type=script&lang=js&"
export * from "./UserAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb4df4",
  null
  
)

export default component.exports